import { render, staticRenderFns } from "./SimpleLabel.vue?vue&type=template&id=adaab604&"
import script from "./SimpleLabel.vue?vue&type=script&lang=js&"
export * from "./SimpleLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports